import { SeriesTabSkeleton } from "@pages/suppliers/_id/_products/investment-product/_id/edit/components/skeletons/SeriesTabSkeleton";

export const ModelsTabSkeleton = () => {
  return <SeriesTabSkeleton />;
};
